import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";

const fmtDate = (dt) => {
  try { return new Date(dt).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit" }); }
  catch { return dt; }
};

export const JournalChart = ({ trades }) => {
  if (!trades || trades.length === 0) return null;
  const sorted = [...trades].sort((a, b) => (a.trade_datetime || "").localeCompare(b.trade_datetime || ""));
  let cum = 0;
  const data = [{ label: "Inizio", cum: 0 }, ...sorted.map((t, i) => {
    cum += parseFloat(t.percentage) || 0;
    return { label: `${fmtDate(t.trade_datetime)} · #${i + 1}`, cum: Math.round(cum * 100) / 100 };
  })];
  const last = data[data.length - 1].cum;
  const color = last >= 0 ? "#2FD8A8" : "#EF4444";

  return (
    <div className="glass-card p-5 sm:p-6 mb-8" data-testid="journal-chart">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-bold uppercase" style={{ color: "var(--mm-text-secondary)", fontFamily: "'Space Grotesk', sans-serif", letterSpacing: "0.1em" }}>Andamento Cumulato (%)</h3>
        <span className="text-lg font-bold" style={{ color: last >= 0 ? "#2FD8A8" : "#EF4444", fontFamily: "'Space Grotesk', sans-serif" }} data-testid="journal-chart-total">
          {last >= 0 ? "+" : ""}{last}%
        </span>
      </div>
      <div style={{ width: "100%", height: 260 }}>
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 5, right: 10, left: -15, bottom: 0 }}>
            <defs>
              <linearGradient id="jchart" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={color} stopOpacity={0.35} />
                <stop offset="100%" stopColor={color} stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
            <XAxis dataKey="label" tick={{ fill: "var(--mm-text-muted)", fontSize: 11 }} tickLine={false} axisLine={{ stroke: "var(--mm-border)" }} />
            <YAxis tick={{ fill: "var(--mm-text-muted)", fontSize: 11 }} tickLine={false} axisLine={false} unit="%" />
            <Tooltip
              contentStyle={{ backgroundColor: "#0b1512", border: "1px solid rgba(47,216,168,0.3)", borderRadius: 0, fontSize: 13 }}
              labelStyle={{ color: "#94A3B8" }}
              formatter={(v) => [`${v >= 0 ? "+" : ""}${v}%`, "Cumulato"]}
            />
            <ReferenceLine y={0} stroke="rgba(255,255,255,0.2)" strokeDasharray="4 4" />
            <Area type="monotone" dataKey="cum" stroke={color} strokeWidth={2.5} fill="url(#jchart)" dot={{ r: 3, fill: color, strokeWidth: 0 }} activeDot={{ r: 5 }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
